export default __webpack_public_path__ + "static/9-e9497947b2cf62246d509f576fb5e868.png";